module.exports = __webpack_public_path__ + "img/eeuu-flag.c6dea706.svg";